import ApiService from "services/ApiService";

const badRequestCode = 400;

export const TyreCheckService = {
	getTyreCheck(jobId) {
		return new Promise((resolve, reject) => {
			ApiService.get(`/asset/TireTask/${jobId}`).then(
				(result) => {
					resolve(result);
				},
				(error) => {
					reject(error);
				});
		});
	},
	updateSignOffAll(jobId) {
		return new Promise((resolve, reject) => {
			ApiService.put(`/asset/TireTask/SignOffAllDefects/${jobId}`, {}).then(
				(result) => {
					resolve(result);
				},
				(error) => {
					if (error.response.status === badRequestCode) {
						reject(error.response);
					} else {
						reject(
							"Unable to sign off all tyre defects. Please try again later."
						);
					}
				});
		});
	},
	signOffDefect(damageId, jobId, defectSignOff) {
		return new Promise((resolve, reject) => {
			ApiService.patch(`/asset/tiretask/${jobId}/damage/${damageId}/signoff`, defectSignOff)
				.then((response) => {
					resolve(response.data);
				})
				.catch((error) => {
					if (error.response.status === badRequestCode) {
						reject(error.response);
					} else {
						reject(
							"Unable to sign off defect. Please try again later."
						);
					}
				});
		});
	},
	generateTireTaskReportSummaryReport(reportParams) {
		return new Promise((resolve, reject) => {
			ApiService.post(`/asset/TireTaskReports/TireTaskReportSummary`, reportParams)
				.then(
				(result) => {
					resolve(result.data);
				},
				(error) => {
					reject(error.response);
				}
			);
		});
	},
	generateTireTaskReportDetailReport(reportParams) {
		return new Promise((resolve, reject) => {
			ApiService.post(`/asset/TireTaskReports/TireTaskDetailReport`, reportParams)
				.then(
					(result) => {
						resolve(result.data);
					},
					(error) => {
						reject(error.response);
					}
				);
		});
	},
}